const Social = ({textColor, icon="fab fa-facebook-f"}) => {
    return (
        <a href="" className={`${textColor} me-4`}>
            <i className={`fa ${icon}`}></i>
        </a>
    )
}

export default Social